import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "@/App.css";
import AppShell from "@/components/AppShell";
import ErrorBoundary from "@/components/ErrorBoundary";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import EmailVerificationPage from "@/pages/EmailVerificationPage";
import BillingPage from "@/pages/BillingPage";
import DashboardPage from "@/pages/DashboardPage";
import HelpPage from "@/pages/HelpPage";
import OnboardingPage from "@/pages/OnboardingPage";
import OperationsPage from "@/pages/OperationsPage";
import PricingPage from "@/pages/PricingPage";
import SettingsPage from "@/pages/SettingsPage";
import StudioPage from "@/pages/StudioPage";
import SupportInboxPage from "@/pages/SupportInboxPage";
import { api } from "@/lib/api";

const operationPaths = [
  "/app/requests",
  "/app/returns",
  "/app/refunds",
  "/app/exchanges",
  "/app/store-credit",
  "/app/fraud",
  "/app/customers",
  "/app/warranty",
];

const studioPaths = ["/app/automation", "/app/analytics", "/app/notifications"];

function WorkspaceRoute({ children }) {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then(() => setChecked(true))
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate]);

  if (!checked) {
    return null;
  }
  return <AppShell>{children}</AppShell>;
}

function RoutedWorkspace() {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/app") {
    return <WorkspaceRoute><DashboardPage /></WorkspaceRoute>;
  }
  if (path === "/app/billing") {
    return <WorkspaceRoute><BillingPage /></WorkspaceRoute>;
  }
  if (path === "/app/settings") {
    return <WorkspaceRoute><SettingsPage /></WorkspaceRoute>;
  }
  if (path === "/app/help") {
    return <WorkspaceRoute><HelpPage /></WorkspaceRoute>;
  }
  if (path === "/app/support") {
    return <WorkspaceRoute><SupportInboxPage /></WorkspaceRoute>;
  }
  if (operationPaths.includes(path)) {
    return <WorkspaceRoute><OperationsPage path={path} /></WorkspaceRoute>;
  }
  if (studioPaths.includes(path)) {
    return <WorkspaceRoute><StudioPage path={path} /></WorkspaceRoute>;
  }
  return <Navigate to="/app" replace />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/forgot-password" element={<AuthPage mode="reset" />} />
      <Route path="/verify-email" element={<EmailVerificationPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/app/*" element={<RoutedWorkspace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <AppRouter />
      </ErrorBoundary>
    </BrowserRouter>
  );
}